import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

/**
 * Em builds com `production: false`, registra falhas de rede (status 0) e 5xx para facilitar QA.
 * A URL já inclui a base da API (apiBaseInterceptor roda antes).
 */
export const httpDiagnosticInterceptor: HttpInterceptorFn = (req, next) => {
  if (environment.production) {
    return next(req);
  }
  return next(req).pipe(
    tap({
      error: (error: unknown) => {
        if (!(error instanceof HttpErrorResponse)) return;
        if (error.status === 0 || error.status >= 500) {
          console.warn('[Taskeo API]', req.method, req.url, `status=${error.status}`, error.message);
        }
      },
    })
  );
};
